export class Attribute {
  value?: string | Record<string, Attribute>;
  label?: string;
  labelText?: string;
  unity?: string | null;
  displayType?: string;
  filterType?: string;
  index?: number;

  [x: string]: unknown;

  public static of(data: any): Attribute {
    const a: Attribute = new Attribute();
    a.value = data.value;
    a.label = data.label;
    a.labelText = data.label.split("(")[0];
    a.unity = data.label.split("(")[1] ? "(" + data.label.split("(")[1] : null;
    a.displayType = data.displayType;
    a.filterType = data.filterType;
    a.index = data.index;
    return a;
  }
}